import { useEffect } from 'react';

export default function RepairCrisis() {
  useEffect(() => { document.title = 'GreenSmart / CUBi — Solving the $3M Repair Crisis'; }, []);
  const src = (process.env.REACT_APP_BACKEND_URL || '') + '/api/static/repair-crisis.html';
  return (
    <iframe
      src={src}
      title="$3M Repair Crisis"
      data-testid="repair-crisis-page"
      style={{ width: '100%', height: 'calc(100vh - 80px)', border: 'none', display: 'block' }}
    />
  );
}
